import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

import { Constants } from '../../../helper/constants';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { FirstContraventionCopy } from '../../../helper/textcopy/policies.text';
import {
  RadioQuestionModel,
  ContraventionQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { ReportsService } from '../../../services/reports.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'first-contravention-policy',
  templateUrl: './first-contravention.component.html',
})
export class FirstContraventionComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = FirstContraventionCopy;
  constants = Constants;

  cancelPcn = new RadioQuestionModel();
  allContraventions = new RadioQuestionModel();
  contraventionsQuestion = new ContraventionQuestionModel();

  constructor(
    public global: Global,
    private reportsService: ReportsService,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setCancelPcnRadioQuestion();
    this.setAllContraventionsRadioQuestion();
    this.setContraventionsQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setCancelPcnRadioQuestion() {
    this.cancelPcn.data = {
      title: this.textCopy.cancelPcnRadioTitle,
      answers: [
        {
          text: 'the first PCN a person receives',
          value: '0',
        },
        {
          text: 'the first PCN a person receives for each contravention (ie cancel the first PCN for contravention x, the first for contravention y, and so on)',
          value: '1',
        },
        {
          text: 'No - we cancel PCNs, but only if the driver gives us a good reason for doing so',
          value: '2',
        },
      ],
    };
  }
  onCancelPcnSelected(answerValue) {
    this.cancelPcn.valueSelected = answerValue;
  }

  setAllContraventionsRadioQuestion() {
    this.allContraventions.data = {
      title: this.textCopy.allContraventionsTitle,
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: 'No, it applies across a selection of contraventions only',
          value: 'n',
        },
      ],
    };
  }
  onAllContraventionsSelected(answerValue) {
    this.allContraventions.valueSelected = answerValue;
  }

  setContraventionsQuestion() {
    this.contraventionsQuestion = {
      active: true,
      options: [
        { value: 'y', text: 'Y' },
        { value: 'n', text: '-' },
      ],
      valuesSelected: [],
    };
  }
  onContraventionsQuestionSelected(answerValue) {
    this.contraventionsQuestion.valuesSelected = answerValue;
    this.contraventionsQuestion.valuesSelected = this.contraventionsQuestion.valuesSelected.slice();
  }

  setSelectedContraventions() {
    this.reportsService.getOffences().subscribe((result) => {
      this.contraventionsQuestion.valuesSelected = [];
      result.forEach((contravention) => {
        // no contravention 15 and 77 for policies
        if (contravention.id === 15 || contravention.id === 77) {
          return;
        }
        const value = this.policiesAnswers[`30_2_${contravention.id}`];
        this.contraventionsQuestion.valuesSelected.push({
          id: contravention.id,
          value: value !== undefined ? value : 'n',
        });
      });
    });
  }

  setSelectedValues() {
    this.cancelPcn.valueSelected = this.policiesAnswers['30_1'];
    this.allContraventions.valueSelected = this.policiesAnswers['30_2'];
    this.setSelectedContraventions();
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '30_1', description: this.cancelPcn.valueSelected },
      { id: '30_2', description: this.allContraventions.valueSelected },
    ];

    this.contraventionsQuestion.valuesSelected.forEach((contravention, index) => {
      policyList.push({ id: `30_2_${contravention['id']}`, description: contravention['value'] });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
